var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPause = function SvgPause(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5C18.6739 12.5 17.4021 13.0268 16.4645 13.9645C15.5268 14.9021 15 16.1739 15 17.5V42.5C15 43.8261 15.5268 45.0979 16.4645 46.0355C17.4021 46.9732 18.6739 47.5 20 47.5C21.3261 47.5 22.5979 46.9732 23.5355 46.0355C24.4732 45.0979 25 43.8261 25 42.5V17.5C25 16.1739 24.4732 14.9021 23.5355 13.9645C22.5979 13.0268 21.3261 12.5 20 12.5ZM40 12.5C38.6739 12.5 37.4021 13.0268 36.4645 13.9645C35.5268 14.9021 35 16.1739 35 17.5V42.5C35 43.8261 35.5268 45.0979 36.4645 46.0355C37.4021 46.9732 38.6739 47.5 40 47.5C41.3261 47.5 42.5979 46.9732 43.5355 46.0355C44.4732 45.0979 45 43.8261 45 42.5V17.5C45 16.1739 44.4732 14.9021 43.5355 13.9645C42.5979 13.0268 41.3261 12.5 40 12.5Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPause, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pause.4cab4fc6.svg";
export { ForwardRef as ReactComponent };